import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserTrade } from '../types';
import './TradeTable.css';

interface TradeTableProps {
  trades: UserTrade[];
  title: string;
  showProfit?: boolean;
}

const formatCurrency = (val: number) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
};

const formatPrice = (val: number) => {
  return `$${val.toFixed(5)}`;
};

const TradeTable: React.FC<TradeTableProps> = ({ trades, title, showProfit = true }) => {
  const { t } = useTranslation();
  return (
    <div className="trade-table-wrap">
      <div className="trade-table-header">
        <h3>{title}</h3>
        <span className="trade-table-count">{trades.length} trades</span>
      </div>
      <div className="trade-table-scroll">
        <table className="trade-table">
          <thead>
            <tr>
              <th>{t('trades.pair')}</th>
              <th>{t('trades.type')}</th>
              <th>{t('trades.entry')}</th>
              {showProfit && <th>{t('trades.exit')}</th>}
              <th>{t('trades.leverage')}</th>
              {showProfit && <th>{t('trades.netPnl')}</th>}
              <th>{t('trades.date')}</th>
              <th>{t('trades.status')}</th>
            </tr>
          </thead>
          <tbody>
            {trades.map(trade => (
              <tr key={trade.id}>
                <td>
                  <span className="trade-pair">{trade.pair}</span>
                </td>
                <td>
                  <span className={`trade-type ${trade.type.toLowerCase()}`}>
                    {trade.type}
                  </span>
                </td>
                <td className="mono">{formatPrice(trade.entryPrice)}</td>
                {showProfit && <td className="mono">{trade.exitPrice ? formatPrice(trade.exitPrice) : '---'}</td>}
                <td><span className="trade-leverage">{trade.leverage}x</span></td>
                {showProfit && (
                  <td className={`mono ${trade.netProfitLoss && trade.netProfitLoss > 0 ? 'positive' : trade.netProfitLoss && trade.netProfitLoss < 0 ? 'negative' : ''}`}>
                    {trade.netProfitLoss != null ? formatCurrency(trade.netProfitLoss) : '---'}
                  </td>
                )}
                <td className="trade-date">{new Date(trade.openedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                <td>
                  <span className={`trade-status ${trade.status.toLowerCase()}`}>
                    <span className="trade-status-dot" />
                    {trade.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TradeTable;
